// import { create } from 'zustand';
// import {
//   PartnerFormState,
//   PartnerFormBasicInfo,
//   PartnerFormServiceDetails,
//   PartnerFormCoverageAreas,
//   PartnerFormAdditionalInfo,
//   PartnerFormListingDetails,
//   PartnerFormPayment,
//   Plan,
//   PartnerFormServiceDetail,
//   PaymentOrder,
// } from './types';

// const initialBasicInfo: PartnerFormBasicInfo = {
//   fullName: '',
//   businessName: '',
//   mobileNumber: '',
//   whatsappNumber: '',
//   gstNumber: '',
//   employeeCode: '',
// };

// const initialServiceDetails: PartnerFormServiceDetails = {
//   services: {
//     category: '',
//     subcategories: [],
//     serviceChargeCategory: 'same',
//   },
// };

// const initialCoverageAreas: PartnerFormCoverageAreas = {
//   selectedPlan: null,
//   selectedHexagons: [],
// };

// const initialAdditionalInfo: PartnerFormAdditionalInfo = {
//   additionalWorkQuantity: undefined,
//   incomeSharingPercentage: 1,
// };

// const initialListingDetails: PartnerFormListingDetails = {
//   listingAmount: 0,
//   selectedCategory: undefined,
//   selectedAreas: [],
//   totalServiceCharge: 0,
// };

// const initialPayment: PartnerFormPayment = {
//   amount: 0,
//   currency: 'INR',
// };

// // LocalStorage keys
// const STORAGE_KEYS = {
//   BASIC_INFO: 'partnerForm_basicInfo',
//   SERVICE_DETAILS: 'partnerForm_serviceDetails',
//   COVERAGE_AREAS: 'partnerForm_coverageAreas',
//   ADDITIONAL_INFO: 'partnerForm_additionalInfo',
//   LISTING_DETAILS: 'partnerForm_listingDetails',
//   CURRENT_STEP: 'partnerForm_currentStep',
// };

// const saveToLocalStorage = (key: string, data: any) => {
//   try {
//     localStorage.setItem(key, JSON.stringify(data));
//   } catch (error) {
//     console.error(`Error saving to localStorage (${key}):`, error);
//   }
// };

// const loadFromLocalStorage = (key: string, defaultValue: any) => {
//   try {
//     const item = localStorage.getItem(key);
//     return item ? JSON.parse(item) : defaultValue;
//   } catch (error) {
//     console.error(`Error loading from localStorage (${key}):`, error);
//     return defaultValue;
//   }
// };

// interface PartnerFormStore extends PartnerFormState {
//   nextStep: () => void;
//   previousStep: () => void;
//   goToStep: (step: number) => void;
//   updateBasicInfo: (data: Partial<PartnerFormBasicInfo>) => void;
//   updateServiceDetails: (data: Partial<PartnerFormServiceDetails>) => void;
//   setService: (service: PartnerFormServiceDetail) => void;
//   updateCoverageAreas: (data: Partial<PartnerFormCoverageAreas>) => void;
//   setCoveragePlan: (plan: Plan | null) => void;
//   setSelectedHexagons: (hexagons: string[]) => void;
//   updateAdditionalInfo: (data: Partial<PartnerFormAdditionalInfo>) => void;
//   updateListingDetails: (data: Partial<PartnerFormListingDetails>) => void;
//   updatePayment: (data: Partial<PartnerFormPayment>) => void;
//   setDocuments: (files: File[]) => void;
//   setUploadedDocumentUrls: (urls: string[]) => void;
//   setError: (field: string, error: string | string[]) => void;
//   clearError: (field: string) => void;
//   clearAllErrors: () => void;
//   setIsSubmitting: (isSubmitting: boolean) => void;
//   setIsCreatingOrder: (isCreating: boolean) => void;
//   setIsUploadingDocuments: (isUploading: boolean) => void;
//   setPaymentOrder: (order: PaymentOrder | undefined) => void;
//   setSubmittedFormId: (id: string) => void;
//   resetForm: () => void;
// }

// export const usePartnerFormStore = create<PartnerFormStore>((set, get) => {
//   const loadInitialState = () => {
//     return {
//       currentStep: loadFromLocalStorage(STORAGE_KEYS.CURRENT_STEP, 1),
//       basicInfo: loadFromLocalStorage(STORAGE_KEYS.BASIC_INFO, initialBasicInfo),
//       serviceDetails: loadFromLocalStorage(STORAGE_KEYS.SERVICE_DETAILS, initialServiceDetails),
//       coverageAreas: loadFromLocalStorage(STORAGE_KEYS.COVERAGE_AREAS, initialCoverageAreas),
//       additionalInfo: loadFromLocalStorage(STORAGE_KEYS.ADDITIONAL_INFO, initialAdditionalInfo),
//       listingDetails: loadFromLocalStorage(STORAGE_KEYS.LISTING_DETAILS, initialListingDetails),
//     };
//   };

//   const initialState = loadInitialState();

//   return {
//     currentStep: initialState.currentStep,
//     totalSteps: 6,
//     basicInfo: initialState.basicInfo,
//     serviceDetails: initialState.serviceDetails,
//     coverageAreas: initialState.coverageAreas,
//     additionalInfo: initialState.additionalInfo,
//     listingDetails: initialState.listingDetails,
//     payment: initialPayment,
//     documents: [],
//     uploadedDocumentUrls: [],
//     errors: {},
//     isSubmitting: false,
//     isCreatingOrder: false,
//     isUploadingDocuments: false,
//     paymentOrder: undefined,
//     submittedFormId: undefined,
//     isSubmitted: false,

//     nextStep: () => {
//       const { currentStep, totalSteps } = get();
//       if (currentStep < totalSteps) {
//         const newStep = currentStep + 1;
//         set({ currentStep: newStep });
//         saveToLocalStorage(STORAGE_KEYS.CURRENT_STEP, newStep);
//       }
//     },

//     previousStep: () => {
//       const { currentStep } = get();
//       if (currentStep > 1) {
//         const newStep = currentStep - 1;
//         set({ currentStep: newStep });
//         saveToLocalStorage(STORAGE_KEYS.CURRENT_STEP, newStep);
//       }
//     },

//     goToStep: (step: number) => {
//       const { totalSteps } = get();
//       if (step >= 1 && step <= totalSteps) {
//         set({ currentStep: step });
//         saveToLocalStorage(STORAGE_KEYS.CURRENT_STEP, step);
//       }
//     },

//     updateBasicInfo: (data) => {
//       set((state) => {
//         const newErrors = { ...state.errors };
//         Object.keys(data).forEach((key) => {
//           delete newErrors[key];
//         });
//         const updatedBasicInfo = { ...state.basicInfo, ...data };
//         saveToLocalStorage(STORAGE_KEYS.BASIC_INFO, updatedBasicInfo);
//         return {
//           basicInfo: updatedBasicInfo,
//           errors: newErrors,
//         };
//       });
//     },

//     updateServiceDetails: (data) => {
//       set((state) => {
//         const updatedServiceDetails = { ...state.serviceDetails, ...data };
//         saveToLocalStorage(STORAGE_KEYS.SERVICE_DETAILS, updatedServiceDetails);
//         return { serviceDetails: updatedServiceDetails };
//       });
//     },

//     setService: (service) => {
//       set(() => {
//         const updatedServiceDetails = { services: service };
//         saveToLocalStorage(STORAGE_KEYS.SERVICE_DETAILS, updatedServiceDetails);
//         return { serviceDetails: updatedServiceDetails };
//       });
//     },

//     updateCoverageAreas: (data) => {
//       set((state) => {
//         const updatedCoverageAreas = { ...state.coverageAreas, ...data };
//         saveToLocalStorage(STORAGE_KEYS.COVERAGE_AREAS, updatedCoverageAreas);
//         return { coverageAreas: updatedCoverageAreas };
//       });
//     },

//     setCoveragePlan: (plan) => {
//       set((state) => {
//         const updatedCoverageAreas = { ...state.coverageAreas, selectedPlan: plan };
//         saveToLocalStorage(STORAGE_KEYS.COVERAGE_AREAS, updatedCoverageAreas);
//         return { coverageAreas: updatedCoverageAreas };
//       });
//     },

//     setSelectedHexagons: (hexagons) => {
//       set((state) => {
//         const updatedCoverageAreas = { ...state.coverageAreas, selectedHexagons: hexagons };
//         saveToLocalStorage(STORAGE_KEYS.COVERAGE_AREAS, updatedCoverageAreas);
//         return { coverageAreas: updatedCoverageAreas };
//       });
//     },

//     updateAdditionalInfo: (data) => {
//       set((state) => {
//         const updatedAdditionalInfo = { ...state.additionalInfo, ...data };
//         saveToLocalStorage(STORAGE_KEYS.ADDITIONAL_INFO, updatedAdditionalInfo);
//         return { additionalInfo: updatedAdditionalInfo };
//       });
//     },

//     updateListingDetails: (data) => {
//       set((state) => {
//         const updatedListingDetails = { ...state.listingDetails, ...data };
//         saveToLocalStorage(STORAGE_KEYS.LISTING_DETAILS, updatedListingDetails);
//         return { listingDetails: updatedListingDetails };
//       });
//     },

//     updatePayment: (data) => {
//       set((state) => ({
//         payment: { ...state.payment, ...data },
//       }));
//     },

//     setDocuments: (files) => {
//       set({ documents: files });
//     },

//     setUploadedDocumentUrls: (urls) => {
//       set({ uploadedDocumentUrls: urls });
//     },

//     setError: (field, error) => {
//       set((state) => ({
//         errors: { ...state.errors, [field]: error },
//       }));
//     },

//     clearError: (field) => {
//       set((state) => {
//         const newErrors = { ...state.errors };
//         delete newErrors[field];
//         return { errors: newErrors };
//       });
//     },

//     clearAllErrors: () => {
//       set({ errors: {} });
//     },

//     setIsSubmitting: (isSubmitting) => {
//       set({ isSubmitting });
//     },

//     setIsCreatingOrder: (isCreating) => {
//       set({ isCreatingOrder: isCreating });
//     },

//     setIsUploadingDocuments: (isUploading) => {
//       set({ isUploadingDocuments: isUploading });
//     },

//     setPaymentOrder: (order) => {
//       set({ paymentOrder: order });
//     },

//     setSubmittedFormId: (id) => {
//       set({ submittedFormId: id, isSubmitted: true });
//     },

//     resetForm: () => {
//       Object.values(STORAGE_KEYS).forEach((key) => {
//         localStorage.removeItem(key);
//       });

//       set({
//         currentStep: 1,
//         basicInfo: initialBasicInfo,
//         serviceDetails: initialServiceDetails,
//         coverageAreas: initialCoverageAreas,
//         additionalInfo: initialAdditionalInfo,
//         listingDetails: initialListingDetails,
//         payment: initialPayment,
//         documents: [],
//         uploadedDocumentUrls: [],
//         errors: {},
//         isSubmitting: false,
//         isCreatingOrder: false,
//         isUploadingDocuments: false,
//         paymentOrder: undefined,
//         submittedFormId: undefined,
//         isSubmitted: false,
//       });
//     },
//   };
// });


import { create } from 'zustand';
import {
  PartnerFormState,
  PartnerFormBasicInfo,
  PartnerFormServiceDetails,
  PartnerFormCoverageAreas,
  PartnerFormAdditionalInfo,
  PartnerFormListingDetails,
  PartnerFormPayment,
  Plan,
  PartnerFormServiceDetail,
  PaymentOrder,
  BranchDetails, // Add this
} from './types';

const initialBasicInfo: PartnerFormBasicInfo = {
  fullName: '',
  businessName: '',
  mobileNumber: '',
  whatsappNumber: '',
  gstNumber: '',
  employeeCode: '',
  district: '',
};

const initialServiceDetails: PartnerFormServiceDetails = {
  services: {
    category: '',
    subcategories: [],
    serviceChargeCategory: 'same',
  },
};

const initialCoverageAreas: PartnerFormCoverageAreas = {
  selectedPlan: null,
  selectedHexagons: [],
};

const initialAdditionalInfo: PartnerFormAdditionalInfo = {
  additionalWorkQuantity: undefined,
  incomeSharingPercentage: 1,
};

const initialListingDetails: PartnerFormListingDetails = {
  listingAmount: 0,
  selectedCategory: undefined,
  selectedAreas: [],
  totalServiceCharge: 0,
};

const initialPayment: PartnerFormPayment = {
  amount: 0,
  currency: 'INR',
};

const initialBranchDetails: BranchDetails | null = null;

// LocalStorage keys
const STORAGE_KEYS = {
  BASIC_INFO: 'partnerForm_basicInfo',
  SERVICE_DETAILS: 'partnerForm_serviceDetails',
  COVERAGE_AREAS: 'partnerForm_coverageAreas',
  BRANCH_DETAILS: 'partnerForm_branchDetails', // Add this
  ADDITIONAL_INFO: 'partnerForm_additionalInfo',
  LISTING_DETAILS: 'partnerForm_listingDetails',
  CURRENT_STEP: 'partnerForm_currentStep',
};

const saveToLocalStorage = (key: string, data: any) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error(`Error saving to localStorage (${key}):`, error);
  }
};

const loadFromLocalStorage = (key: string, defaultValue: any) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    console.error(`Error loading from localStorage (${key}):`, error);
    return defaultValue;
  }
};

interface PartnerFormStore extends PartnerFormState {
  nextStep: () => void;
  previousStep: () => void;
  goToStep: (step: number) => void;
  updateBasicInfo: (data: Partial<PartnerFormBasicInfo>) => void;
  updateServiceDetails: (data: Partial<PartnerFormServiceDetails>) => void;
  setService: (service: PartnerFormServiceDetail) => void;
  updateCoverageAreas: (data: Partial<PartnerFormCoverageAreas>) => void;
  setCoveragePlan: (plan: Plan | null) => void;
  setSelectedHexagons: (hexagons: string[]) => void;
  updateBranchDetails: (data: Partial<BranchDetails>) => void; // Add this
  setBranchDetails: (branch: BranchDetails | null) => void; // Add this
  updateAdditionalInfo: (data: Partial<PartnerFormAdditionalInfo>) => void;
  updateListingDetails: (data: Partial<PartnerFormListingDetails>) => void;
  updatePayment: (data: Partial<PartnerFormPayment>) => void;
  setDocuments: (files: File[]) => void;
  setUploadedDocumentUrls: (urls: string[]) => void;
  setError: (field: string, error: string | string[]) => void;
  clearError: (field: string) => void;
  clearAllErrors: () => void;
  setIsSubmitting: (isSubmitting: boolean) => void;
  setIsCreatingOrder: (isCreating: boolean) => void;
  setIsUploadingDocuments: (isUploading: boolean) => void;
  setPaymentOrder: (order: PaymentOrder | undefined) => void;
  setSubmittedFormId: (id: string) => void;
  resetForm: () => void;
}

export const usePartnerFormStore = create<PartnerFormStore>((set, get) => {
  const loadInitialState = () => {
    return {
      currentStep: loadFromLocalStorage(STORAGE_KEYS.CURRENT_STEP, 1),
      basicInfo: loadFromLocalStorage(STORAGE_KEYS.BASIC_INFO, initialBasicInfo),
      serviceDetails: loadFromLocalStorage(STORAGE_KEYS.SERVICE_DETAILS, initialServiceDetails),
      coverageAreas: loadFromLocalStorage(STORAGE_KEYS.COVERAGE_AREAS, initialCoverageAreas),
      branchDetails: loadFromLocalStorage(STORAGE_KEYS.BRANCH_DETAILS, initialBranchDetails),
      additionalInfo: loadFromLocalStorage(STORAGE_KEYS.ADDITIONAL_INFO, initialAdditionalInfo),
      listingDetails: loadFromLocalStorage(STORAGE_KEYS.LISTING_DETAILS, initialListingDetails),
    };
  };

  const initialState = loadInitialState();

  return {
    currentStep: initialState.currentStep,
    totalSteps: 7, // Updated to 7 steps
    basicInfo: initialState.basicInfo,
    serviceDetails: initialState.serviceDetails,
    coverageAreas: initialState.coverageAreas,
    branchDetails: initialState.branchDetails,
    additionalInfo: initialState.additionalInfo,
    listingDetails: initialState.listingDetails,
    payment: initialPayment,
    documents: [],
    uploadedDocumentUrls: [],
    errors: {},
    isSubmitting: false,
    isCreatingOrder: false,
    isUploadingDocuments: false,
    paymentOrder: undefined,
    submittedFormId: undefined,
    isSubmitted: false,

    nextStep: () => {
      const { currentStep, totalSteps } = get();
      if (currentStep < totalSteps) {
        const newStep = currentStep + 1;
        set({ currentStep: newStep });
        saveToLocalStorage(STORAGE_KEYS.CURRENT_STEP, newStep);
      }
    },

    previousStep: () => {
      const { currentStep } = get();
      if (currentStep > 1) {
        const newStep = currentStep - 1;
        set({ currentStep: newStep });
        saveToLocalStorage(STORAGE_KEYS.CURRENT_STEP, newStep);
      }
    },

    goToStep: (step: number) => {
      const { totalSteps } = get();
      if (step >= 1 && step <= totalSteps) {
        set({ currentStep: step });
        saveToLocalStorage(STORAGE_KEYS.CURRENT_STEP, step);
      }
    },

    updateBasicInfo: (data) => {
      set((state) => {
        const newErrors = { ...state.errors };
        Object.keys(data).forEach((key) => {
          delete newErrors[key];
        });
        const updatedBasicInfo = { ...state.basicInfo, ...data };
        saveToLocalStorage(STORAGE_KEYS.BASIC_INFO, updatedBasicInfo);
        return {
          basicInfo: updatedBasicInfo,
          errors: newErrors,
        };
      });
    },

    updateServiceDetails: (data) => {
      set((state) => {
        const updatedServiceDetails = { ...state.serviceDetails, ...data };
        saveToLocalStorage(STORAGE_KEYS.SERVICE_DETAILS, updatedServiceDetails);
        return { serviceDetails: updatedServiceDetails };
      });
    },

    setService: (service) => {
      set(() => {
        const updatedServiceDetails = { services: service };
        saveToLocalStorage(STORAGE_KEYS.SERVICE_DETAILS, updatedServiceDetails);
        return { serviceDetails: updatedServiceDetails };
      });
    },

    updateCoverageAreas: (data) => {
      set((state) => {
        const updatedCoverageAreas = { ...state.coverageAreas, ...data };
        saveToLocalStorage(STORAGE_KEYS.COVERAGE_AREAS, updatedCoverageAreas);
        return { coverageAreas: updatedCoverageAreas };
      });
    },

    setCoveragePlan: (plan) => {
      set((state) => {
        const updatedCoverageAreas = { ...state.coverageAreas, selectedPlan: plan };
        saveToLocalStorage(STORAGE_KEYS.COVERAGE_AREAS, updatedCoverageAreas);
        return { coverageAreas: updatedCoverageAreas };
      });
    },

    setSelectedHexagons: (hexagons) => {
      set((state) => {
        const updatedCoverageAreas = { ...state.coverageAreas, selectedHexagons: hexagons };
        saveToLocalStorage(STORAGE_KEYS.COVERAGE_AREAS, updatedCoverageAreas);
        return { coverageAreas: updatedCoverageAreas };
      });
    },

    // New branch methods
    updateBranchDetails: (data) => {
      set((state) => {
        const updatedBranchDetails = { ...state.branchDetails, ...data } as BranchDetails;
        saveToLocalStorage(STORAGE_KEYS.BRANCH_DETAILS, updatedBranchDetails);
        return { branchDetails: updatedBranchDetails };
      });
    },

    setBranchDetails: (branch) => {
      set(() => {
        saveToLocalStorage(STORAGE_KEYS.BRANCH_DETAILS, branch);
        return { branchDetails: branch };
      });
    },

    updateAdditionalInfo: (data) => {
      set((state) => {
        const updatedAdditionalInfo = { ...state.additionalInfo, ...data };
        saveToLocalStorage(STORAGE_KEYS.ADDITIONAL_INFO, updatedAdditionalInfo);
        return { additionalInfo: updatedAdditionalInfo };
      });
    },

    updateListingDetails: (data) => {
      set((state) => {
        const updatedListingDetails = { ...state.listingDetails, ...data };
        saveToLocalStorage(STORAGE_KEYS.LISTING_DETAILS, updatedListingDetails);
        return { listingDetails: updatedListingDetails };
      });
    },

    updatePayment: (data) => {
      set((state) => ({
        payment: { ...state.payment, ...data },
      }));
    },

    setDocuments: (files) => {
      set({ documents: files });
    },

    setUploadedDocumentUrls: (urls) => {
      set({ uploadedDocumentUrls: urls });
    },

    setError: (field, error) => {
      set((state) => ({
        errors: { ...state.errors, [field]: error },
      }));
    },

    clearError: (field) => {
      set((state) => {
        const newErrors = { ...state.errors };
        delete newErrors[field];
        return { errors: newErrors };
      });
    },

    clearAllErrors: () => {
      set({ errors: {} });
    },

    setIsSubmitting: (isSubmitting) => {
      set({ isSubmitting });
    },

    setIsCreatingOrder: (isCreating) => {
      set({ isCreatingOrder: isCreating });
    },

    setIsUploadingDocuments: (isUploading) => {
      set({ isUploadingDocuments: isUploading });
    },

    setPaymentOrder: (order) => {
      set({ paymentOrder: order });
    },

    setSubmittedFormId: (id) => {
      set({ submittedFormId: id, isSubmitted: true });
    },

    resetForm: () => {
      Object.values(STORAGE_KEYS).forEach((key) => {
        localStorage.removeItem(key);
      });

      set({
        currentStep: 1,
        basicInfo: initialBasicInfo,
        serviceDetails: initialServiceDetails,
        coverageAreas: initialCoverageAreas,
        branchDetails: initialBranchDetails,
        additionalInfo: initialAdditionalInfo,
        listingDetails: initialListingDetails,
        payment: initialPayment,
        documents: [],
        uploadedDocumentUrls: [],
        errors: {},
        isSubmitting: false,
        isCreatingOrder: false,
        isUploadingDocuments: false,
        paymentOrder: undefined,
        submittedFormId: undefined,
        isSubmitted: false,
      });
    },
  };
});